import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import GridNew from "~components/atoms/grid_new/grid_new";
import SRChapterCard from "~components/molecules/specialised_report/sr_chapter_card/sr_chapter_card";
import ModalContain from "~components/organisms/modal/modal_contain/modal_contain";
import { createInternalLink } from "~utils/link_utils/createInternalLink/createInternalLink";
import TOCIconButton from "../toc_icon_button/toc_icon_button";
import { chaptersWrapperStyle } from "./toc_chapters_modal_controller.module.scss";

const GRID_SPLIT = { XXL: "3", M: "2", XS: "1" };

function TOCChaptersModalController({
  allChaptersTitle,
  chapters,
  collectionTitle,
  currentChapterIndex,
  isNavExpanded,
  isSmall,
  pagePath,
}) {
  const [isDownloadModalActive, setIsDownloadModalActive] = useState(false);

  const toggleModal = useCallback(() => {
    return setIsDownloadModalActive((currentState) => {
      return !currentState;
    });
  }, []);
  const closeModal = useCallback(() => {
    return setIsDownloadModalActive(false);
  }, []);

  return (
    <>
      <TOCIconButton
        onClick={toggleModal}
        isNavExpanded={isNavExpanded}
        icon="icon_chapters"
        title={allChaptersTitle}
        isSmall={isSmall}
      />

      <ModalContain
        callbackToCloseModal={closeModal}
        closeModal={closeModal}
        isModalActive={isDownloadModalActive}
        modalTitle={collectionTitle}
      >
        <div className={chaptersWrapperStyle}>
          <GridNew split={GRID_SPLIT}>
            {chapters?.length > 0 &&
              chapters.map((chapter, index) => {
                if (chapter.field_title_string) {
                  return (
                    <SRChapterCard
                      callbackOnClick={closeModal}
                      chapterNumber={index + 1}
                      isCardActive={currentChapterIndex === index}
                      key={chapter.field_title_string}
                      link={createInternalLink(chapter.full_slug)}
                      pagePath={pagePath}
                      slug={chapter.full_slug}
                      title={chapter.field_title_string}
                    />
                  );
                }
                return null;
              })}
          </GridNew>
        </div>
      </ModalContain>
    </>
  );
}

TOCChaptersModalController.propTypes = {
  allChaptersTitle: PropTypes.string,
  chapters: PropTypes.arrayOf(
    PropTypes.shape({
      field_title_string: PropTypes.string,
      full_slug: PropTypes.string,
    })
  ),
  collectionTitle: PropTypes.string,
  currentChapterIndex: PropTypes.number,
  isNavExpanded: PropTypes.bool,
  isSmall: PropTypes.bool,
  pagePath: PropTypes.string,
};

TOCChaptersModalController.defaultProps = {
  allChaptersTitle: null,
  chapters: null,
  collectionTitle: null,
  currentChapterIndex: null,
  isNavExpanded: false,
  isSmall: false,
  pagePath: null,
};

export default TOCChaptersModalController;
